'use strict';

var _rollupPluginBabelHelpers = require('../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var ReactSelect = require('react-select');
require('react-select/dist/react-select.css');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var ReactSelect__default = /*#__PURE__*/_interopDefaultLegacy(ReactSelect);

var Select = /*#__PURE__*/function (_React$PureComponent) {
  _rollupPluginBabelHelpers.inherits(Select, _React$PureComponent);

  var _super = _rollupPluginBabelHelpers.createSuper(Select);

  function Select() {
    _rollupPluginBabelHelpers.classCallCheck(this, Select);

    return _super.apply(this, arguments);
  }

  _rollupPluginBabelHelpers.createClass(Select, [{
    key: "buildClassName",
    value: function buildClassName() {
      return ['ds-atom-vendor-select-input-normal', this.props.error ? 'error' : null, this.props.className].filter(function (x) {
        return x;
      }).join(' ');
    }
  }, {
    key: "render",
    value: function render() {
      var className = this.buildClassName();

      var selectProps = _rollupPluginBabelHelpers.objectSpread2({}, this.props, {
        className: className
      });

      return /*#__PURE__*/React__default['default'].createElement(ReactSelect__default['default'], selectProps);
    }
  }]);

  return Select;
}(React__default['default'].PureComponent);

_rollupPluginBabelHelpers.defineProperty(Select, "propTypes", ReactSelect__default['default'].propTypes);

_rollupPluginBabelHelpers.defineProperty(Select, "defaultProps", _rollupPluginBabelHelpers.objectSpread2({}, ReactSelect__default['default'].defaultProps));

module.exports = Select;
